"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IVisibleItemsContextContext = exports.VisibleItemsContext = void 0;
var Observable_1 = require("icf-search-client-shared/lib/observables/Observable");
var react_1 = __importDefault(require("react"));
var VisibleItemsContext = /** @class */ (function () {
    function VisibleItemsContext() {
        this._visibleItemsState = new Observable_1.Observable({
            range: { start: 0, end: 0 },
            items: [],
        });
    }
    VisibleItemsContext.prototype.update = function (dataSource, range) {
        var items = Array.from(dataSource.getItemsInRange(range));
        this._visibleItemsState.value = {
            range: {
                start: range.start + dataSource.itemRange.value.start,
                end: range.end + dataSource.itemRange.value.start,
            },
            items: items.filter(function (item) { return !!item; }),
        };
    };
    Object.defineProperty(VisibleItemsContext.prototype, "visibleItemsState", {
        get: function () {
            return this._visibleItemsState.asReadonly();
        },
        enumerable: false,
        configurable: true
    });
    return VisibleItemsContext;
}());
exports.VisibleItemsContext = VisibleItemsContext;
exports.IVisibleItemsContextContext = react_1.default.createContext(null);
//# sourceMappingURL=VisibleItemsContext.js.map